import { Injectable } from '@angular/core';
import { CommonUtil, LoginService, MessageService, DateTableColumn, IdentifierTableColumn, RadioComponent, SelectDialogComponent, TableColumn } from '@serengeti/serengeti-common';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class CloudAccountPoolService {

  endPoint: string;

  constructor(
    private dialog: MatDialog,
    private messageService: MessageService,
    private loginService: LoginService
  ) {
		this.endPoint = CommonUtil.buildEndPoint(environment.serviceResourceCoreEndPoint, 'pool');
  }

	doBrowsePool(vendor: string): Observable<any> {
		const poolDialogRef = this.dialog.open(SelectDialogComponent, {
			width: '80%',
			height: '80%',
			data: {
				title: "cloud-account.pool.select.dialog.pool.title",
				query: CommonUtil.buildEndPoint(environment.serviceResourceCoreEndPoint, 'pool/search?isShared=true&vendor=' + vendor),
				method: 'page',
				columns: [
					new IdentifierTableColumn('id', 'cloud-account.pool.select.content.columns.id')
          .withValueVisible(false)
          .withType(RadioComponent),
					new TableColumn('name', 'cloud-account.pool.select.content.columns.name'),
					new TableColumn('region.cloud.name', 'cloud-account.pool.select.content.columns.cloud'),
					new TableColumn('region.name', 'cloud-account.pool.select.content.columns.region'),
					new DateTableColumn('createdDate', 'cloud-account.pool.select.content.columns.created-date')
          .withStyles('cellCenter')
				],
				selectButtonLabel: 'cloud-account.pool.select.dialog.pool.buttons.ok'
			}
		});

		return poolDialogRef.afterClosed();
  }

  get(id: string): Observable<any> {
    const url = CommonUtil.buildEndPoint(this.endPoint, id, '/');

    return this.messageService.query(url).pipe((res) => {
      this.loginService.extendTimeout();
      return res;
    });
  }

	cloudAutomation(cloud: any): Observable<any> {
		let url = CommonUtil.buildEndPoint(environment.serviceResourceCoreEndPoint, 'cloud/automated');

    return this.messageService.post(url, cloud);
	}

  save(account: any, vmPool: any, k8sPool?: any): Observable<any> {
    const url = CommonUtil.buildEndPoint(environment.serviceCloudAccountEndPoint, 'account', account.id.toString(), '/');
    const pools = [];

    if (vmPool) {
      pools.push({
        usage: 'Server',
        poolId: vmPool.id,
        poolName: vmPool.name
      });
    }
    if (k8sPool) {
      pools.push({
        usage: 'Container',
        poolId: k8sPool.id,
        poolName: k8sPool.name
      });
    }

    return this.messageService.put(url, {
      id: account.id,
      type: account.type,
      pools: pools
    }).pipe((res) => {
      this.loginService.extendTimeout();
      return res;
    });
  }

}
